<template>
    <!--header-->
    <header class="header text-center">
        <div class="header-inner-v4 c-nav4 px-15">
            <a class="c-nav4__icon h--burger-icon j--toggle-menu h--show-md">
                <span class="planer h1"><img src="@/assets/icon-hamburguer-slate.svg"></span>
            </a>
            <router-link to="/alege-dispozitiv" class="c-nav4__logo h--show-md">
                <img id="iqos-svg-logo" src="@/assets/logo-pocket-horizontal.svg">
            </router-link>
            <nav id="main-nav-v4" class="c-nav4__first__wrapper__inner">
                <div class="c-nav4__overlay"></div>
                <ul class="c-nav4__first">
                    <li class="c-nav4__first__item has--sub">
                        <a data-name="IQOS World" data-nav_taxonomy="" data-url="javascript:void(0);" href="javascript:void(0);" class="c-nav4__first__item__link js--level1-animation">
                            Intrebări frecvente
                        </a>
                        <div class="c-nav4__second__wrapper">
                            <span class="c-nav4__second__wrapper__title">Intrebări frecvente</span>
                            <div class="c-nav4__second__wrapper__inner">
                                <ul class="c-nav4__second">

                                    <li @click="faqMenuTrack(category)" v-for="category in faq" :key="category.categoryId"
                                        class="c-nav4__second__item" :data-name="category.categoryTitle" data-nav_taxonomy="" data-url="#">
                                        <router-link @mouseup.native="collpaseMenu" class="c-nav4__second__item__link" :to="'/faq/' + category.categoryId">
                                            {{ category.categoryTitle }}
                                        </router-link>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </li>
                    <li class="c-nav4__logo h--hide-md">
                        <router-link class="c-nav4__logo_link js--level1-animation" to="/alege-dispozitiv">
                            <img id="iqos-svg-logo" src="@/assets/logo-pocket-horizontal.svg">
                        </router-link>
                    </li>
                </ul>
                <div class="js--level1-animation">
                    <div class="c-language-switcher">
                        <svg id="icons-pictogram-contact" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
                          <path data-name="Path 1017" d="M0,0H64V64H0Z" fill="rgba(0,0,0,0)" fill-rule="evenodd"/>
                          <g transform="translate(9.547 11.733)">
                            <path d="M28.189,29.984l2.5-2.5a4.864,4.864,0,0,1,6.88,0l3.16,3.157a3.886,3.886,0,0,1,0,5.5h0a13.23,13.23,0,0,1-16.9,1.507L22.36,36.456,9.02,22.981,3.087,17.043a8.634,8.634,0,0,1,0-12.209L6.549,1.376a3.744,3.744,0,0,1,5.293,0L16.368,5.9a3.74,3.74,0,0,1,0,5.287l-2.344,2.351a3.739,3.739,0,0,0-.883,1.408L28.189,29.984Z" transform="translate(-0.56 1.16)" fill="none" stroke="#34303d" stroke-linejoin="round" stroke-width="2.5" fill-rule="evenodd"/>
                            <path d="M39.631,28.468a16.329,16.329,0,0,0-14.16-13.789M45.523,32.316c.029-.475.045-.953.045-1.436A22.08,22.08,0,0,0,23.488,8.8c-.657,0-1.309.029-1.952.085" transform="translate(-2.368 -8.8)" fill="none" stroke="#00d1d2" stroke-linecap="round" stroke-width="2" fill-rule="evenodd"/>
                          </g>
                        </svg>

                        <div>Suntem aici pentru tine</div>
                        <div>Nu ai găsit încă răspunsul la întrebarea ta? Contactează-ne la numărul <a href="tel:0800030333" class="text-turquoise">0800.030.333</a></div>
                        <div>Luni - Vineri: 08:00 - 22:00</div>
                    </div>
                </div>
            </nav>
            <a class="c-nav4__icon h--close-icon j--toggle-menu">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#272A33" fill-rule="evenodd" d="M17.778.803l1.415 1.414-7.78 7.778 7.78 7.778-1.415 1.415L10 11.408l-7.778 7.78-1.414-1.415 7.778-7.778L.808 2.217 2.222.803 10 8.58 17.778.803z" />
                </svg>
            </a>
            <a class="c-nav4__icon h--back-icon js--hide-menu-l2">
                <svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512">
                    <path d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z" />
                </svg>
            </a>
            <a class="c-nav4__icon h--back-icon j--hide-menu-l3">
                <svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512">
                    <path d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z" />
                </svg>
            </a>
        </div>
    </header>
    <!--end header-->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";

export default {
    name: 'AppHeader',
    computed: {
        ...mapGetters(['faq']),
    },
    methods: {
        faqMenuTrack(category) {
			dataLayer.push({
                'event': 'gtmZoneEvent', 
                'eventCategory': 'iqos_pocket', 
                'eventAction': `click_faq_menu | ${category.categoryTitle}`,
                'eventLabel': `${category.categoryTitle}`
			});
		},
        collpaseMenu () {
            var windowWidth = $(window).width();
            var isTablet = windowWidth <= 960;
            if (isTablet) {
                $('.h--close-icon.j--toggle-menu').first().click();
            }
            else {
                $('.c-nav4__first__item__link').first().click();
            }
        },
        init () {

            var windowWidth, windowHeight, isTablet, isMobile, isDesktop, triggerResize;
            var isMobileBurgerClicked = false;
            var pageBody = $('body');
            var nav = $('#main-nav-v4');
            var navOverlay = $('.c-nav4__overlay');
            var navItemsLevel1 = $('.c-nav4__first__item');
            var navItemsLevel2 = $('.c-nav4__second__item');
            var navItemsLevel3 = $('.c-nav4__third__item');
            var closeMenuLevel2Button = $('.js--hide-menu-l2');
            var closeMenuLevel3Button = $('.j--hide-menu-l3');
            var rtl = $('.right-to-left');
            var autoHideControl = null;
            var targetLockElement = nav.length ? nav[0] : null;
            var navScrollPos = 0;

            function resizeWindow() {

                var widthResized = $(window).width() !== windowWidth;

                windowWidth = $(window).width();
                windowHeight = $(window).height();
                isTablet = windowWidth <= 960;
                isMobile = windowWidth <= 640;
                isDesktop = windowWidth > 960;
                document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01)+"px");

                if(isMobile && !widthResized) return;
                
                resetStates();
                if( nav.length ) { toggleBodyScroll( false ); }
            }
            resizeWindow();

            window.onresize = function () {
                clearTimeout(triggerResize);
                triggerResize = setTimeout(resizeWindow, 200);
            };

            function resetStates() {
                isMobileBurgerClicked = false;
                toggleMenuLevel3();
                isTablet && closeMenuLevel2();
                isTablet && closeMenuMobileLevel1();
                // Reset all animations
                TweenMax.set([
                    $('.c-nav_slider'),
                    $('.c-nav4__first__wrapper__inner'),
                    navItemsLevel1,
                    navItemsLevel1.children(),
                    navItemsLevel2,
                    navOverlay
                ], {clearProps: "all"});

                nav.parent('div').removeClass('h--menu-open');
                if (isMobile) {
                    closeMenuLevel2Button.off('click').on('click', function () {
                        closeMenuLevel2();
                    });
                }
            }

            function toggleBodyScroll(isBlocked) {
                /*
                if(!targetLockElement)return;
                if(isMobile){
                    $("body").css({
                        "position": isBlocked ? "fixed" : ""
                    });
                } else {
                    if (isBlocked) {
                        bodyScrollLock.disableBodyScroll(targetLockElement);
                    } else {
                        bodyScrollLock.enableBodyScroll(targetLockElement);
                    }
                }
                */
            }

            function toggleOverlay(isShown) {
                if (isShown) {
                    TweenMax.to(navOverlay, .6, {
                        opacity: 0.8,
                        display: 'block'
                    });
                    toggleBodyScroll(true);
                } else {
                    navOverlay.next().removeClass('has--active');
                    TweenMax.to(navOverlay, .4, {
                        opacity: 0,
                        display: 'none',
                        onComplete: function () {
                            if(autoHideControl)autoHideControl.resume();
                        }
                    });
                    toggleBodyScroll(false);
                }
            }

            function openMenuMobileLevel1() {
                
                navScrollPos = $(window).scrollTop();

                if(autoHideControl)autoHideControl.pause();

                var _this = $('.c-nav4__first__wrapper__inner');
                var l1_animation_elements = $('.js--level1-animation, .js--level1-animation--subtitle');
                var l1_animation_subtitle_elements = $('.js--level1-animationis--subtitle');

                TweenMax.fromTo(_this, .6, {x: '-100%'}, {
                    x: '0%',
                    display: 'block',
                    ease: Cubic.easeOut,
                    onComplete: function() {
                        toggleOverlay(true);     
                    }
                });

                TweenMax.staggerFromTo(l1_animation_elements, .6, {x: -40, opacity: 0}, {
                    x: 0,
                    opacity: 1,
                    delay: 0.4
                }, 0.1);

                // Separate subtitle animation to make link and subtitle appear at the same time
                TweenMax.staggerFromTo(l1_animation_subtitle_elements, .6, {x: -40, opacity: 0}, {
                    x: 0,
                    opacity: 1,
                    delay: 0.4
                }, 0.1);
            }

            function closeMenuMobileLevel1() {
                toggleOverlay();

                if( isMobile ){ $(window).scrollTop(navScrollPos); }

                TweenMax.fromTo($('.c-nav4__first__wrapper__inner'), .6, {x: '0%'}, {
                    x: '-100%',
                    display: 'none',
                    ease: Cubic.easeOut
                });
                closeMenuLevel2Button.removeClass('is--secondary');
            }

            function openMenuLevel2(_this) {
                var level2_wrapper = _this.find('.c-nav4__second__wrapper');
                var level2_link = _this.find('.c-nav4__second__item__link');
                var level2_subtitle = _this.find('.c-nav4__second__item__subtitle');
                var additional_content = _this.find('.c-additional_content')    ;

                if(autoHideControl)autoHideControl.pause();


                _this
                    .find('.c-nav4__second').removeClass('has--active')
                    .find(navItemsLevel2).removeClass('is--sibling-hovered').removeClass('is--active');

                navItemsLevel1.each(function () {
                    if ($(this).hasClass('is--active')) {
                        closeMenuLevel2($(this), !isTablet);
                        toggleMenuLevel3($(this));
                    }
                });

                _this.addClass('is--active');
                $('.h--close-icon').addClass('is--secondary');

                if (isMobile) {
                    closeMenuLevel2Button.addClass('is--secondary');
                    TweenMax.fromTo(level2_wrapper, .6, {opacity: 0}, {
                        opacity: 1,
                        ease: Cubic.easeOut,
                        display: 'block'
                    });
                } else if (isTablet) {
                    TweenMax.fromTo(level2_wrapper, .6, {transform: 'scaleX(0)'}, {
                        transform: 'scaleX(1)',
                        ease: Cubic.easeOut,
                        display: 'block'
                    });
                } else {
                    TweenMax.fromTo(level2_wrapper, .6, {transform: 'scaleY(0)'}, {
                        transform: 'scaleY(1)',
                        ease: Cubic.easeOut
                    });
                }

                TweenMax.staggerFromTo(level2_link, .6, {x: isTablet ? -20 : -40, opacity: 0}, {
                    x: 0,
                    opacity: 1,
                    delay: 0.4
                }, 0.04);

                TweenMax.staggerFromTo([level2_subtitle, additional_content], .6, {x: isTablet ? -20 : -40, opacity: 0}, {
                    x: 0,
                    opacity: 1,
                    delay: 0.4
                }, 0.04);
            }

            function closeMenuLevel2(_this, isWrapperPersisting) {
                _this = _this || navItemsLevel1;
                navItemsLevel1.parent().removeClass('has--active');
                var level2_wrapper = _this.find('.c-nav4__second__wrapper');
                var level2_link = _this.find('.c-nav4__second__item__link');
                var level2_subtitle = _this.find('.c-nav4__second__item__subtitle');
                var additional_content = _this.find('.c-additional_content');
                TweenMax.fromTo([level2_link, level2_subtitle, additional_content], .1, {opacity: 1}, {opacity: 0});

                if (isMobile) {
                    TweenMax.fromTo(level2_wrapper, 0.4, {opacity: 1}, {
                        opacity: 0,
                        ease: Cubic.easeOut,
                        display: 'none'
                    });
                } else if (isTablet) {
                    TweenMax.fromTo(level2_wrapper, 0.4, {transform: 'scaleX(1)'}, {
                        transform: 'scaleX(0)',
                        ease: Cubic.easeOut,
                    });
                    toggleMenuLevel3();

                } else {
                    TweenMax.fromTo(level2_wrapper, 0.4, {transform: 'scaleY(1)'}, {
                        transform: 'scaleY(0)',
                        ease: Cubic.easeOut,
                        delay: isWrapperPersisting ? 0.55 : 0.2
                    });
                }
                _this.removeClass('is--active');

                $('.h--close-icon').removeClass('is--secondary');
                closeMenuLevel3Button.removeClass('is--secondary');
                closeMenuLevel2Button.removeClass('is--secondary');
            }

            function toggleMenuLevel3(currentNavItemLevel2, isShown) {
                currentNavItemLevel2 = currentNavItemLevel2 || navItemsLevel2;

                var level3_items = currentNavItemLevel2.find('.c-nav4__third__item__link');
                var level3_wrapper = currentNavItemLevel2.find('.c-nav4__third__wrapper');
                var additional_content = currentNavItemLevel2.find('.c-additional_content');
                var slider = currentNavItemLevel2.find('.c-nav_slider');

                if (isShown) {
                    TweenMax.killTweensOf(level3_items);
                    TweenMax.fromTo(level3_wrapper, .6, {display: 'none'}, {display: 'block'});

                    if (isTablet) {
                        if (isMobile) {
                            TweenMax.fromTo(slider, .1, {display: 'none'}, {
                                display: 'block', onComplete: function () {
                                    $('.c-nav_slider').flickity('resize');
                                }
                            });
                        }
                        TweenMax.staggerFromTo(level3_items, .6, {y: 40, opacity: 0}, {
                            y: 0,
                            opacity: 1,
                            delay: 0.1,
                        }, 0.08);
                    } else {
                        TweenMax.staggerFromTo(level3_items, .6, {y: 40, opacity: 0}, {
                            y: 0,
                            opacity: 1,
                            delay: 0.1,
                        }, 0.08);
                    }

                    TweenMax.staggerFromTo(slider, .6, {y: 40, opacity: 0}, {
                        y: 0,
                        opacity: 1,
                        delay: 0.1,
                    }, 0.08);

                    closeMenuLevel3Button.addClass('is--secondary');
                } else {
                    if (isTablet) {
                        isMobile && TweenMax.fromTo( slider, .1, {display: 'block'}, {display: 'none'});
                        TweenMax.fromTo([level3_items, additional_content], .3, {opacity: 1}, {opacity: 0});
                        currentNavItemLevel2
                            .removeClass('is--sibling-hovered is--active')
                            .parent().removeClass('has--active');

                    } else {
                        TweenMax.fromTo( level3_items, .3, {opacity: 1}, {opacity: 0});
                    }
                    level3_wrapper.hide();
                    closeMenuLevel3Button.removeClass('is--secondary');

                    if (isMobile) {
                        closeMenuLevel2Button.addClass('is--secondary');
                    }
                }
            }

            /**
             *  Push Google dataLayer by proper level of navigation menu
             * @param element [jQuery object]
             * @param level [number]
             */
            function pushDataLayerByLevel(element, level) {
                return false;
                if(!dataLayer) { return; }

                var data = element.data();
                var name = data.name;

                if (!data.nav_taxonomy || !data.name || !data.url ) {
                    console.warn('Some of dataLayer fields are missing for level:' + level + '. Please check if all navigation contains following fields: nav_taxonomy, name and url.');
                }

                if( level === 3 ) {
                    // We need to search for title and subtitle because it's included in "Additional HTML" field in backend
                    var title = element.find('span.is--title');
                    var subtitle = element.find('span.is--subtitle');
                    if (title.text()) {
                        name = subtitle.text() ? title.text() + ' ' + subtitle.text() : title.text();
                    } else if (subtitle.text()) {
                        name = subtitle.text();
                    }
                }

                dataLayer.push({
                    'event': 'navigationMenu',
                    'navMenuLevel': level.toString(),                                                               // 1 to 3
                    'navMenuLevelGlobalName': data.nav_taxonomy ? data.nav_taxonomy.toString().toLowerCase() : '',  // '#MENU_TAXONOMY#',
                    'navMenuItemLocalText': name ? name.toString().toLowerCase() : '',                              // '#MENU_TITLE#',
                    'navMenuItemUrl': data.url                                                                      // '#MENU_TARGET_URL#'
                        ? ~data.url.indexOf('javascript') ? 'n/a' : data.url
                        : '',
                });
            }

            // Event Handlers
            navOverlay.on('click', function () {
                if (isDesktop) {
                    closeMenuLevel2($('.c-nav4__first__item.is--active'));
                }
                toggleOverlay();
            });

            navItemsLevel1.on('click', '.c-nav4__first__item__link', function () {
                var _this = $(this);
                pushDataLayerByLevel(_this, 1);

                var currentItem = _this.parent();
                if (!currentItem.hasClass('has--sub')) {
                    isTablet && navItemsLevel1.each(function () {
                        _this.hasClass('is--active') && closeMenuLevel2($(this));
                    });
                } else if (currentItem.hasClass('is--active')) {
                    toggleBodyScroll(false);
                    closeMenuLevel2(currentItem);
                    isDesktop && toggleOverlay();
                    currentItem.parent().removeClass('has--active');
                } else {
                    openMenuLevel2(currentItem);
                    toggleOverlay(true);
                    currentItem.parent().addClass('has--active');
                }
            });

            navItemsLevel2.on('click',  function (e) {
                var isLevel2ItemTargetted= $(e.target).hasClass('c-nav4__second__item') || ($(e.currentTarget).hasClass('c-nav4__second__item') && $(e.target).hasClass('c-nav4__second__item__link'));
                var _this = $(this);

                // To avoid pushing into dataLayer when children of Leve2Item is clicked
                if( isLevel2ItemTargetted ) {
                    pushDataLayerByLevel(_this, 2);
                }

                _this.siblings().addClass('is--sibling-hovered');
                if (!_this.hasClass('is--active')) {
                    if (!_this.hasClass('is--active') && _this.hasClass('has--sub')) {
                        toggleMenuLevel3(_this, true);
                    }
                    navItemsLevel2.removeClass('is--active');
                    _this.addClass('is--active').removeClass('is--sibling-hovered').parent().addClass('has--active');
                }
            });

            navItemsLevel3.on('click', function() {
                pushDataLayerByLevel($(this), 3);
            });

            $('.j--toggle-menu, .c-nav4__overlay').on('click', function () {
                if (isTablet) {
                    if (!isMobileBurgerClicked) {
                        openMenuMobileLevel1();
                        nav.parent('div').addClass('h--menu-open');
                    } else {
                        if (navItemsLevel1.hasClass('is--active')) {
                            closeMenuLevel2();
                            toggleMenuLevel3();
                        }
                        closeMenuMobileLevel1();
                        nav.parent('div').removeClass('h--menu-open');
                    }
                    isMobileBurgerClicked = !isMobileBurgerClicked;
                }
            });

            closeMenuLevel3Button.on('click', function () {
                toggleMenuLevel3();
            });


            nav
                .on('mouseover', '.c-nav4__first__item', function () {
                    $(this).siblings().addClass('is--sibling-hovered');
                })
                .on('mouseleave', '.c-nav4__first__item', function () {
                    $(this).siblings().removeClass('is--sibling-hovered');
                })
                .on('mouseover mouseleave', '.c-nav4__second__item', function (e) {
                    e.stopPropagation();
                })
                .on('mouseover', '.c-nav4__third__item', function () {
                    $(this).siblings().addClass('is--sibling-hovered');
                    $(this).addClass('is--active');
                })
                .on('mouseleave', '.c-nav4__third__item', function () {
                    $(this).siblings().removeClass('is--sibling-hovered');
                    $(this).removeClass('is--active');
                });
            // !Event Handlers

        },
        kill () {

        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        this.kill();
    }
};
</script>
